<template>
  <div :class="{ 'upload--small': small }" class="upload">
    <label
      :for="componentId"
      class="upload__area"
      :class="{ loading: loading }"
      @drag.prevent
      @drop="handleDropFiles"
      @dragover="handleDragOver"
      @dragleave="handleDragLeave"
    >
      <v-icon> mdi-folder-upload-outline </v-icon>
      {{ multiple ? $t('upload.label') : $t('upload.singleLabel') }}
      <small class="upload__or">
        {{ $t('upload.or') }}
      </small>
      <span class="upload__button" large>
        {{ $t('upload.select') }}
      </span>
    </label>
    <input
      @change="handleEmitFiles"
      :disabled="loading"
      :accept="fileTypes"
      :multiple="multiple"
      :id="componentId"
      :ref="componentId"
      type="file"
    />
  </div>
</template>

<script>
export default {
  name: 'HUpload',

  props: {
    small: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    componentId: {
      type: String,
      default: 'filesUpload',
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    fileTypes: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      files: [],
    }
  },

  methods: {
    sanitizeFileName(fileName) {
      const [name, extension] = fileName.split(/(?=\.[^.]+$)/)
      const sanitized = name.replace(/[^a-zA-Z0-9-_]/g, "")
      return sanitized + (extension || '')
    },

    applySanitizedFileName(files) {
      return Array.from(files).map((file) => {
        const sanitizedFileName = this.sanitizeFileName(file.name)
        return new File([file], sanitizedFileName, { type: file.type })
      })
    },

    handleEmitFiles(event) {
      const files = this.applySanitizedFileName(event.target?.files)
      this.$emit('change', files)
    },

    handleDropFiles(event) {
      event.preventDefault()
      const files = this.applySanitizedFileName(event.dataTransfer?.files)
      this.$emit('change', files)
    },

    handleDragOver(event) {
      event.preventDefault()
      event.target.parentElement.classList.add('upload__area--dragover')
    },

    handleDragLeave(event) {
      event.preventDefault()
      event.target.parentElement.classList.remove('upload__area--dragover')
    },

    resetUploadField() {
      const uploadInput = document.querySelector(`#${this.documentId}`)
      uploadInput && (uploadInput.value = '')
   },
  },
}
</script>
